export default "__VITE_ASSET__CYev2krD__"